// Client-side repo-name validation (RFC-0002 Task 3.2).
//
// Mirrors the server allow-list in apps/api/src/lib/repo-name.ts EXACTLY so the
// modal can gate submit and show inline errors before any network call. The
// server re-validates — this is a UX affordance, not the security boundary.
//
// Rule: ^[A-Za-z0-9._-]{1,100}$ (plus rejecting the reserved "." / ".." names).

export const REPO_NAME_PATTERN = /^[A-Za-z0-9._-]{1,100}$/;

export const REPO_NAME_ERROR_MESSAGE =
  'Repository name must match ^[A-Za-z0-9._-]{1,100}$';

export type RepoNameValidation =
  | { ok: true; name: string }
  | { ok: false; message: string };

export function validateRepoName(raw: string): RepoNameValidation {
  const name = raw.trim();
  if (!REPO_NAME_PATTERN.test(name) || name === '.' || name === '..') {
    return { ok: false, message: REPO_NAME_ERROR_MESSAGE };
  }
  return { ok: true, name };
}

/** Convenience predicate for disabling the submit button. */
export function isValidRepoName(raw: string): boolean {
  return validateRepoName(raw).ok;
}
